// @flow
import ClubFinder from 'components/club/ClubFinder';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/club/ClubFinder';
import { fetchClubs } from 'actions/clubsActions';

export default connect(
  (state: StateType): StateProps => ({
    blocs_trouver_club: state.settingsState.blocs_trouver_club,
    clubs: state.clubsState.clubs,
    featured_image: state.settingsState.bloc_trouver_club.featured_image,
    keycloakData: state.userState.keycloakData,
    pratiques: state.settingsState.pratiques_clubs,
    pratiques_ok: state.searchState.pratiques_ok,
    searchCities: [],
    searchClubs: [],
    searchTypes: [],
    status: state.clubsState.status,
    userPref: state.userState.userPref,
    userPrefStatus: state.userState.status
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchClubsPreview: () => dispatch(fetchClubs())
  })
)(ClubFinder);
